'use client';

import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useAuth } from 'react-oidc-context';

import { Check, Close } from '@zoomit/icons';
import { Col, Flex, IconButton, Spacing } from '@zoomit/primitives';
import { cssVar, Input, theme } from '@zoomit/zoomit-ds';

type Props = {
  closeForm: () => void;
  isSubmitting?: boolean;
};

const ArticleBookmarkEditForm = (props: Props) => {
  const { isSubmitting = false, closeForm } = props;
  const { isAuthenticated } = useAuth();
  const { watch, register } = useFormContext();

  return (
    <Flex className="w-full" alignItems="center" justifyContent="space-between">
      <Col md={11} size={9}>
        <Input {...register('name')} placeholder="نام لیست را وارد کنید" />
      </Col>
      <Col md={1} size={3}>
        <Flex gap={Spacing.x3} justifyContent="flex-end">
          <IconButton disabled={!isAuthenticated || isSubmitting || watch('name')?.length < 1} type="submit">
            <Check size="dl" fill={cssVar(theme.success1)} />
          </IconButton>
          <IconButton onClick={() => closeForm()}>
            <Close size="dl" fill={cssVar(theme.grey1)} />
          </IconButton>
        </Flex>
      </Col>
    </Flex>
  );
};

export default memo(ArticleBookmarkEditForm);
